import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Cookies from "js-cookie";
import DateRangePicker from "../../../../DatePickers/DateRangePicker/DateRangePicker";
import FacilityDateRangePicker from "../../../../DatePickers/DateRangePicker/FacilityDateRangePicker";
import Select from "react-select";
import ReactLoading from "react-loading";
import Dropdown from "react-dropdown";
import TrendingAnalysisAPI from "../../../../../api/TrendingAnalysisApi";
import { AccumulatedParser } from "../../../../../parser/TrendingAnalysis";
import Form from "react-bootstrap/Form";

const formatDate = (date) => {
    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
};

export default function AccumulatedTab({ tabData, setTabData, setPlotOrder }) {
    const token = Cookies.get("Session");

    // extracting from redux slice
    const { selectedCustomer, selectedFacility, equipmentsList, equipmentTimezone, selectedEquipment } = useSelector(
        (state) => state.equipmentsPortfolio
    );
    const selectedVoltageType = useSelector((state) => state.voltageType.selectedVoltageType);

    const firstStartDate = selectedFacility
        ? new Date(
              parseInt(
                  Math.min(
                      ...equipmentsList.map((eq) => {
                          return isNaN(eq.equipment_start_epoch) ? Infinity : eq.equipment_start_epoch;
                      })
                  ) * 1000
              )
          )
        : new Date();

    const getOneYearAgo = () => {
        const d = new Date();
        d.setFullYear(d.getFullYear() - 1);
        return d;
    };

    const [startDate, setStartDate] = useState(getOneYearAgo());
    const [endDate, setEndDate] = useState(new Date());

    const [plotLoading, setPlotLoading] = useState(false);
    const [alertBanner, setAlertBanner] = useState({
        color: "",
        show: false,
        text: "",
    });

    useEffect(() => {
        setAlertBanner({ ...alertBanner, show: false });
    }, [selectedCustomer, selectedFacility]);

    const onPlotButtonClick = () => {
        if (selectedFacility == null) {
            //Set Alert
            setAlertBanner({
                color: "primary",
                text: "Select Facility to Plot",
                show: true,
            });
            return null;
        } else {
            setAlertBanner({ ...alertBanner, show: false });
            setPlotLoading(true);
            setTabData((prevData) => {
                return {
                    ...prevData,
                    isPlotLoading: true,
                    showPlot: true,
                    plotData: {},
                    selectedFacility: selectedFacility,
                    plotMetaData: {
                        selectedFacility: selectedFacility,
                        v_type: selectedVoltageType.value,
                        startDate: formatDate(startDate),
                        endDate: formatDate(endDate),
                        timezone: equipmentTimezone.value,
                    },
                };
            });

            TrendingAnalysisAPI.getFacilityPQ(
                token,
                selectedFacility.facility_id,
                formatDate(startDate),
                formatDate(endDate),
                equipmentTimezone.value
            ).then((response) => {
                setPlotLoading(false);
                if (response.status === 204) {
                    setAlertBanner({
                        color: "primary",
                        show: true,
                        text: "No Data Found",
                    });
                    setTabData((prevData) => {
                        return {
                            ...prevData,
                            showPlot: false,
                            isPlotLoading: false,
                        };
                    });
                } else if (response.status === 200) {
                    setTabData((prevData) => {
                        return {
                            ...prevData,
                            plotData: response.data.content,
                            showPlot: true,
                            isPlotLoading: false,
                        };
                    });
                } else {
                    setAlertBanner({
                        color: "primary",
                        show: true,
                        text: "Error Fetching Data",
                    });
                    setTabData((prevData) => {
                        return {
                            ...prevData,
                            showPlot: false,
                            isPlotLoading: false,
                        };
                    });
                }
            });
        }
    };

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <h2 className="margin-top-10">Facility PQ</h2>{" "}
                </Col>
            </Row>
            <Row>
                <Col className="minute-dateRange-input col-6">
                    <label>Select Date Range:</label>
                    <br></br>
                    <DateRangePicker
                        startDate={startDate}
                        endDate={endDate}
                        onStartDateChange={setStartDate}
                        onEndDateChange={setEndDate}
                        minStartDate={firstStartDate}
                    />
                </Col>
            </Row>
            <Row>
                <Col className="col-2">
                    {plotLoading ? (
                        <ReactLoading type="bars" height={50} width={50} color="#007bff" />
                    ) : (
                        <Button variant="primary" onClick={onPlotButtonClick} className="plot_button">
                            Plot
                        </Button>
                    )}
                </Col>
                <Col className="col-5 trendingAlert">
                    <Alert
                        variant={alertBanner.color}
                        show={alertBanner.show}
                        onClose={() => setAlertBanner({ ...alertBanner, show: false })}
                        dismissible
                    >
                        {alertBanner.text}
                    </Alert>
                </Col>
            </Row>
        </React.Fragment>
    );
}
